import { gql } from "@stadium/services/apollo-client";

export const fetchRewardUser = gql`
  query fetchRewardUser @api(name: "rewards") {
    currentUser {
      id
      rewardPoints
    }
  }
`;

export const fetchWorkspacePoints = gql`
  query fetchPoints($slug: String!) @api(name: "users") {
    currentWorkspaceUser(slug: $slug) {
      id
      workspacePoints
    }
  }
`;
